module.exports = __webpack_public_path__ + "4a32b8362a9c1aed5badf117b100ce49.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/product_placement.png
// module id = 586
// module chunks = 0